module.exports = __webpack_public_path__ + "static/media/visa.e8e04d92.svg";